import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ConsultaFuenteI } from 'src/app/modelos/ConsultaFuente';
import { ResConsultaExcel } from 'src/app/modelos/ResConsulta';
import { VigenciaI } from 'src/app/modelos/VigenciaReporte';
import { ApiService } from 'src/app/servicios/api/api.service';
import { AppServiceService } from 'src/app/servicios/AppService.service';
import * as XLSX from 'xlsx';
import { ResCargueExcelAdminInfFiviI } from 'src/app/modelos/ResCargueExcelAdminInfFivi';


@Component({
  selector: 'app-consultareport',
  templateUrl: './consultareport.component.html',
  styleUrls: ['./consultareport.component.css']
})
export class ConsultareportComponent implements OnInit {

  AnualDis : Boolean;
  TrimestreDis : Boolean;
  Anual : Boolean;
  Trimestre : Boolean;
  BtnDescarga : Boolean;

  TipoFuente : any;

  Anios : VigenciaI[];

  Consultar : ConsultaFuenteI = new ConsultaFuenteI;
  ResultadoConsulta : any;
  Saldo : BigInteger;
  NombreArchivo : string = "";

  constructor(
    private activerouter: ActivatedRoute,
    private router: Router,
    private api: ApiService,
    private toastr: ToastrService,
    private appService:AppServiceService
  ) { }

  ngOnInit(): void {
    this.AnualDis = false;
    this.TrimestreDis = false;
    this.Anual = false;
    this.Trimestre = false;
    this.BtnDescarga = false;
    this.TipoFuente = localStorage.getItem('tipo');
    this.Consultar.anio = 0;
    this.Consultar.trimestre = 0;
    this.api.getUsuarioByUsername(localStorage.getItem("usuario")).subscribe(data=>{
      this.api.getFuenteById(data.fuente).subscribe(Fuente=>{
        this.Consultar.cod_entidad = Fuente.codEnti;
        this.Consultar.idFuente = Fuente.id;
      });
    });
    if (localStorage.getItem('tipo') == "CHV"){
      this.api.listaAniosConsultaChv().subscribe(data=>{
        this.Anios = data;
      });
    } else if (localStorage.getItem('tipo') == "FIVI") {
      this.api.listaAniosConsultaFivi().subscribe(data=>{
        this.Anios = data;
      });
    }
  }

  SeleccionPeriodo(){
    if (this.Anual){
      this.TrimestreDis = true;
      this.Trimestre = false;
    } else if (this.Trimestre){
      this.AnualDis = true;
      this.Anual = false;
    } else if (!this.Anual && !this.Trimestre){
      this.AnualDis = false;
      this.TrimestreDis = false;
      this.Anual = false;
      this.Trimestre = false;
    }
  }

  setAnioValue(anioSelec){
    this.Consultar.anio = anioSelec;
  }

  setTrimestreValue(trimestreSelec){
    this.Consultar.trimestre = trimestreSelec;
  }

  consultarHistorico(){
    if (!this.Anual && !this.Trimestre){
      this.toastr.warning('Debe seleccionar el tipo de consulta.', 'Advertencia!');
    } else if ((this.Consultar.anio == '0'|| this.Consultar.anio == null) && this.Anual){
      this.toastr.warning('Debe seleccionar la vigencia.', 'Advertencia!');
    } else if ((this.Consultar.anio == '0' || this.Consultar.trimestre == '0' || this.Consultar.anio == null || this.Consultar.trimestre == null) && this.Trimestre){
      this.toastr.warning('Debe seleccionar la vigencia y el trimestre.', 'Advertencia!');
    } else {
      if(this.Consultar.trimestre == 0){this.NombreArchivo = this.Consultar.anio;}else{this.NombreArchivo = this.Consultar.anio+" - "+this.Consultar.trimestre;}
      if (this.TipoFuente == "CHV"){
        this.api.consultarHistoricoCHV(this.Consultar).subscribe(result1 =>{
          if(result1.length == 0){
            this.BtnDescarga = false;
            this.toastr.warning('La fuente no reportó en el periodo seleccionado.', 'Advertencia!');
          } else {
            this.BtnDescarga = true;
            this.ResultadoConsulta = result1;
          }
        }, error1 =>{
          this.toastr.warning('La fuente no reportó en el periodo seleccionado.', 'Advertencia!');
        });
      }
      if (this.TipoFuente == "FIVI") {
        this.api.consultarHistoricoFIVI(this.Consultar).subscribe(result2 =>{
          if(result2.length == 0){
            this.BtnDescarga = false;
            this.toastr.warning('La fuente no reportó en el periodo seleccionado.', 'Advertencia!');
          } else {
            this.BtnDescarga = true;
            this.ResultadoConsulta = result2;
          }
        }, error2 =>{
          this.toastr.warning('La fuente no reportó en el periodo seleccionado.', 'Advertencia!');
        });
      }
    }
  }

  /*downloadChv(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById('ConsultaChv'));
    XLSX.utils.book_append_sheet(workbook, ws1, "Hoja1");
    XLSX.writeFile(workbook, "Consulta "+this.NombreArchivo+".xlsx");
  }*/

  downloadChv() {
    const encabezados = {
      consecutivo: 'Consecutivo',
      anio: 'Anio',
      trimestre: 'Trimestre',
      tipo_de_credito: 'Tipo de crédito',
      departamento: 'Departamento',
      municipio: 'Municipio',
      solucion_vivienda: 'Solución vivienda',
      tenedor: 'Tenedor',
      moneda: 'Moneda',
      rango_vivienda: 'Rango vivienda',
      mora: 'Mora',
      numero_creditos: 'Número créditos',
      saldo_capital_total: 'Saldo capital total',
      capital_una_mas_cuotas_vencidad: 'Capital una o más cuotas vencidas',
      tasa: 'Tasa'
    };
  
    const datosFormateados = this.ResultadoConsulta.map((row: any) => ({
      consecutivo: row.consecutivo,
      anio: row.anio,
      trimestre: row.trimestre,
      tipo_de_credito: row.tipo_de_credito,
      departamento: row.departamento,
      municipio: row.municipio,
      solucion_vivienda: row.solucion_vivienda,
      tenedor: row.tenedor,
      moneda: row.moneda,
      rango_vivienda: row.rango_vivienda,
      mora: row.mora,
      numero_creditos: row.numero_creditos,
      saldo_capital_total: row.saldo_capital_total,
      capital_una_mas_cuotas_vencidad: row.capital_una_mas_cuotas_vencidad,
      tasa: parseFloat(row.tasa.toString().replace(',', '.'))
    }));
  
    const ws = XLSX.utils.json_to_sheet(datosFormateados);
  
    // Insertar encabezados personalizados
    XLSX.utils.sheet_add_aoa(ws, [Object.values(encabezados)], { origin: 'A1' });
  
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Hoja1');
  
    XLSX.writeFile(wb, 'Consulta ' + this.NombreArchivo + '.xlsx');
  }

  downloadFivi(){
    var workbook = XLSX.utils.book_new();
    var ws1 = XLSX.utils.table_to_sheet(document.getElementById('ConsultaFivi'));
    XLSX.utils.book_append_sheet(workbook, ws1, "Hoja1");
    XLSX.writeFile(workbook, "Consulta "+this.NombreArchivo+".xlsx");
  }

}
